import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_ALERT_RULES,
  GET_AZURE_ALERT_RULES_SUCCESS,
  GET_AZURE_ALERT_RULES_ERROR,
} from "./constant";

import { getAzureAlertRulesApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureAlertRulesList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureAlertRulesApi, params, provider);
    yield put({ type: GET_AZURE_ALERT_RULES_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_ALERT_RULES_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureAlertRulesSaga() {
  yield takeLatest(GET_AZURE_ALERT_RULES, getAzureAlertRulesList);
}
